import { Dispatch } from "redux";
import { Conversation } from "@twilio/conversations";

import { EngagementPhase, Notification, PreEngagementData, SyncMapItemData } from "../definitions";
import {
    ACTION_ADD_MULTIPLE_MESSAGES,
    ACTION_ADD_NOTIFICATION,
    ACTION_ATTACH_FILES,
    ACTION_CHANGE_ENGAGEMENT_PHASE,
    ACTION_CHANGE_EXPANDED_STATUS,
    ACTION_DETACH_FILES,
    ACTION_GLANCE_BUTTON_PRESS,
    ACTION_GLANCE_CONNECT,
    ACTION_GLANCE_ERROR,
    ACTION_GLANCE_RESET,
    ACTION_REMOVE_NOTIFICATION,
    ACTION_UPDATE_PRE_ENGAGEMENT_DATA,
    ACTION_UPDATE_PRE_ENGAGEMENT_FIELD_VALUE,
    ACTION_UPDATE_SYNC_MAP_ITEM_DATA
} from "./actionTypes";
import { MESSAGES_LOAD_COUNT } from "../../constants";

export function changeEngagementPhase({ phase }: { phase: EngagementPhase }) {
    return {
        type: ACTION_CHANGE_ENGAGEMENT_PHASE,
        payload: {
            currentPhase: phase
        }
    };
}

export function addNotification(notification: Notification) {
    return {
        type: ACTION_ADD_NOTIFICATION,
        payload: {
            notification
        }
    };
}

export function removeNotification(id: string) {
    return {
        type: ACTION_REMOVE_NOTIFICATION,
        payload: {
            id
        }
    };
}

export function getMoreMessages({ anchor, conversation }: { anchor: number; conversation: Conversation }) {
    return async (dispatch: Dispatch) =>
        dispatch({
            type: ACTION_ADD_MULTIPLE_MESSAGES,
            payload: {
                messages: (await conversation.getMessages(MESSAGES_LOAD_COUNT, anchor)).items
            }
        });
}

export function changeExpandedStatus({ expanded }: { expanded: boolean }) {
    return {
        type: ACTION_CHANGE_EXPANDED_STATUS,
        payload: {
            expanded
        }
    };
}

export function attachFiles(files: File[]) {
    return {
        type: ACTION_ATTACH_FILES,
        payload: {
            filesToAttach: files
        }
    };
}

export function detachFiles(files: File[]) {
    return {
        type: ACTION_DETACH_FILES,
        payload: {
            filesToDetach: files
        }
    };
}

export function updatePreEngagementData(data: Partial<PreEngagementData>) {
    return {
        type: ACTION_UPDATE_PRE_ENGAGEMENT_DATA,
        payload: {
            preEngagementData: data
        }
    };
}

export function updatePreEngagementFieldValue(key: string, value: string) {
    return {
        type: ACTION_UPDATE_PRE_ENGAGEMENT_FIELD_VALUE,
        payload: {
            key,
            value
        }
    };
}

export function updateSyncMapItemData(data: SyncMapItemData | undefined) {
    return {
        type: ACTION_UPDATE_SYNC_MAP_ITEM_DATA,
        payload: {
            syncMapItemData: data
        }
    };
}

export function glanceError(error: Error) {
    return {
        type: ACTION_GLANCE_ERROR,
        payload: {
            error
        }
    };
}

export function glanceConnected() {
    return {
        type: ACTION_GLANCE_CONNECT
    };
}

export function glanceReset() {
    return {
        type: ACTION_GLANCE_RESET
    };
}

export function glanceConnect(sessionId: string) {
    return (dispatch: Dispatch) => {
        window.GLANCE.Cobrowse.Visitor.startSession(sessionId);

        dispatch({
            type: ACTION_GLANCE_BUTTON_PRESS
        });
    };
}
